import "./style.css";

interface ISpinnerProps {
  isVisible?: boolean;
}

const Spinner = ({ isVisible }: ISpinnerProps) => {
  if (isVisible) document.documentElement.style.overflow = "hidden";
  else document.documentElement.style.overflow = "auto";
  return isVisible || isVisible === undefined ? (
    <>
      <div className="h-screen w-screen bg-black bg-opacity-50 fixed top-0 left-0  z-40" />
      <div>
        <div className="fixed bottom-10 right-10 z-50">
          <div className="spinner_spin">
            <div className="sk-chase">
              <div className="sk-chase-dot"></div>
              <div className="sk-chase-dot"></div>
              <div className="sk-chase-dot"></div>
              <div className="sk-chase-dot"></div>
              <div className="sk-chase-dot"></div>
              <div className="sk-chase-dot"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : null;
};

export default Spinner;
